var PromiseEnv = require('core/lib/promise').Promise;
var observeSelector = require('./src/observe_selector').observeSelector;
var poll = require('./src/poll').poll;
var waitForElement = require('./src/wait_for_element').waitForElement;
var waitUntil = require('./src/wait_until').waitUntil;

exports.create = function() {
  return {
    observeSelector: observeSelector,
    poll: poll,
    Promise: PromiseEnv,
    waitForElement: waitForElement,
    waitUntil: waitUntil,
  };
};
